import { ChartImage, Container, Title } from './Example.styles'

const Example = () => (
  <Container>
    <Title>Each line will represent a category in your chart</Title>
    <ChartImage />
  </Container>
)

export default Example
